import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'

function Separator({
	className,
	orientation = 'horizontal',
	decorative = true,
	...props
}: React.ComponentProps<'div'> & {
	orientation?: 'horizontal' | 'vertical'
	decorative?: boolean
}) {
	return (
		<div
			data-slot="separator"
			role={decorative ? 'none' : 'separator'}
			aria-orientation={decorative ? undefined : orientation}
			data-orientation={orientation}
			className={cn(
				'shrink-0 bg-white/10 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
				className,
			)}
			{...props}
		/>
	)
}

export { Separator }
